import React, { FunctionComponent } from "react";
import { Box, Flex, Spinner, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const LoadingFallback: FunctionComponent = (): JSX.Element => {
	const { t } = useTranslation();

	return (
		<Flex justifyContent={"space-between"}>
			<Box></Box>
			<Flex display={"inline-flex"} alignItems={"center"} borderRadius="md" p={10} px={20} my={30}>
				<Spinner size="sm" mr={10} />
				<Text fontFamily="Poppins" fontSize="sm" fontWeight="medium" role="heading" textAlign={"center"}>
					{t("classroomDetails.hallwayPassLoading")}
				</Text>
			</Flex>
			<Box></Box>
		</Flex>
	);
};

export default LoadingFallback;
